import { render, staticRenderFns } from "./OurServices.vue?vue&type=template&id=e5038ea0&scoped=true"
import script from "./OurServices.vue?vue&type=script&lang=js"
export * from "./OurServices.vue?vue&type=script&lang=js"
import style0 from "./OurServices.vue?vue&type=style&index=0&id=e5038ea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5038ea0",
  null
  
)

export default component.exports